export default __webpack_public_path__ + "static/icons-694993c9b3c229025ee2c5386c2e1969.svg";